import { NuqsAdapter } from "nuqs/adapters/react";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";

import PrivateRoute from "./components/routing/private-route";
import AppLayout from "./layouts/app";
import { ForgotPassword, LoginPage, ResetPassword } from "./views";

export default () => {
  return (
    <Router>
      <NuqsAdapter>
        <Switch>
          <PrivateRoute path={"/app"}>
            <AppLayout></AppLayout>
          </PrivateRoute>
          <Route path="/login" component={LoginPage} />
          <Route path="/reset-password" component={ResetPassword} />
          <Route path="/create-account" component={ResetPassword} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="*">
            <Redirect to={"/app"} />
          </Route>
        </Switch>
      </NuqsAdapter>
    </Router>
  );
};
